import script from "./TraitShopItems.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShopItems.vue?vue&type=script&setup=true&lang=js"

import "./TraitShopItems.vue?vue&type=style&index=0&id=c37f56f4&lang=scss"

const __exports__ = script;

export default __exports__